import React, { useState } from 'react';
import '../../components/shared/LoginPage.scss';
import './InviteAccept.scss';
import company from '../../config/companyInfo';

const LOGO_URL = 'https://www.esaienergy.com/hubfs/Imported_Blog_Media/638777a841191e721b31c1f5_ESAI%20Logo_Black-p-500-1.png';

const PASSWORD_HINT = 'At least 8 characters with uppercase, lowercase, a number, and a special character.';

function getTokenFromPath() {
    const match = window.location.pathname.match(/^\/invite\/(.+)$/);
    return match ? match[1] : null;
}

export default function InviteAccept() {
    const token = getTokenFromPath();
    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [state, setState] = useState('idle'); // 'idle' | 'submitting' | 'success' | 'error'
    const [errorMessage, setErrorMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMessage('');

        if (password !== confirm) {
            setErrorMessage('Passwords do not match.');
            return;
        }

        setState('submitting');
        try {
            const res = await fetch(`${import.meta.env.VITE_API_BASE_URL}/redeemInvite`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token, password }),
            });
            const data = await res.json().catch(() => ({}));
            if (res.ok && data.success) {
                setState('success');
            } else {
                setErrorMessage(data.details || data.error || 'Something went wrong. Please try again.');
                setState('error');
            }
        } catch {
            setErrorMessage('Unable to connect. Please check your connection and try again.');
            setState('error');
        }
    };

    if (!token) {
        return (
            <div className="lp-root">
                <header className="lp-header">
                    <div className="lp-header-inner">
                        <img src={LOGO_URL} alt="ESAI Energy" className="lp-header-logo" />
                    </div>
                </header>
                <main className="lp-main">
                    <div className="lp-card invite-card">
                        <div className="lp-card-header">
                            <div className="lp-card-logo-row">
                                <img src={LOGO_URL} alt="ESAI Energy" className="lp-card-logo" />
                                <span className="lp-card-title">ESAI Connect</span>
                            </div>
                        </div>
                        <div className="invite-body">
                            <h2>Invalid Invite Link</h2>
                            <p>This invite link is not valid. Please check your email for the correct link or contact your administrator.</p>
                            <a href="/" className="lp-login-btn">Go to Sign In</a>
                        </div>
                    </div>
                </main>
            </div>
        );
    }

    return (
        <div className="lp-root">
            <header className="lp-header">
                <div className="lp-header-inner">
                    <img src={LOGO_URL} alt="ESAI Energy" className="lp-header-logo" />
                </div>
            </header>
            <main className="lp-main">
                <div className="lp-card invite-card">
                    <div className="lp-card-header">
                        <div className="lp-card-logo-row">
                            <img src={LOGO_URL} alt="ESAI Energy" className="lp-card-logo" />
                            <span className="lp-card-title">ESAI Connect</span>
                        </div>
                    </div>

                    <div className="invite-body">
                        {state === 'success' ? (
                            <div className="invite-success">
                                <div className="invite-success-icon">✓</div>
                                <h2>Password Set Successfully</h2>
                                <p>Your account is now active. Click below to sign in with your email and new password.</p>
                                <a href="/" className="lp-login-btn">Sign In</a>
                            </div>
                        ) : (
                            <>
                                <h2>Activate Your Account</h2>
                                <p className="invite-desc">Welcome to ESAI Connect. Set a password below to activate your account.</p>
                                <form className="invite-form" onSubmit={handleSubmit}>
                                    <label className="lp-label">
                                        Password
                                        <div className="invite-input-wrap">
                                            <input
                                                className="lp-input"
                                                type={showPassword ? 'text' : 'password'}
                                                value={password}
                                                onChange={e => setPassword(e.target.value)}
                                                required
                                                disabled={state === 'submitting'}
                                                autoComplete="new-password"
                                            />
                                            <button type="button" className="invite-show-pw" onClick={() => setShowPassword(v => !v)} tabIndex={-1}>
                                                {showPassword ? 'Hide' : 'Show'}
                                            </button>
                                        </div>
                                    </label>
                                    <label className="lp-label">
                                        Confirm Password
                                        <div className="invite-input-wrap">
                                            <input
                                                className="lp-input"
                                                type={showPassword ? 'text' : 'password'}
                                                value={confirm}
                                                onChange={e => setConfirm(e.target.value)}
                                                required
                                                disabled={state === 'submitting'}
                                                autoComplete="new-password"
                                            />
                                        </div>
                                    </label>
                                    <p className="invite-hint">{PASSWORD_HINT}</p>
                                    {(state === 'error' || errorMessage) && (
                                        <p className="lp-contact-error">{errorMessage}</p>
                                    )}
                                    <button
                                        type="submit"
                                        className="lp-login-btn"
                                        disabled={state === 'submitting'}
                                    >
                                        {state === 'submitting' ? 'Activating…' : 'Activate Account'}
                                    </button>
                                </form>
                            </>
                        )}
                    </div>

                    <div className="lp-card-footer">
                        <span>{company.name}</span>
                        <span className="lp-footer-sep">|</span>
                        <span>{company.address}</span>
                    </div>
                </div>
            </main>
        </div>
    );
}
